import { isDomContentLoaded } from '../../../modules/get_perfomance'
import { getQueryParamAll, getQueryParam } from '../../../modules/get_query'
import { set_redirect404 } from '../../../modules/set_redirectUrl'
import { getCode } from '../../../modules/get_code'

import apiPathname from '../../../json/apiPathname.json'

// import buildSidebarRound from '../common/buildSidebarRound'
import buildTournament from '../common/buildTournament'
import buildRunDateInfo from '../common/buildRoundDateInfo'
import buildRun from './buildRun'
import buildResult from './buildResult'
import buildAnchor from './buildAnchor'
import buildMigratoryRace from './buildMigratoryRace'
import buildModal from '../../common/buildModal'

import createDiscontinuationElement from '../common/createDiscontinuationElement';

export default () => {
  const raceId = getQueryParam('race_id');
  if (!raceId) {
    set_redirect404();
    return
  }

  const queryObject = getQueryParamAll();
  const isSp = window.matchMedia('(max-width: 768px)').matches;
  const init = () => {
    // console.log(queryObject);

    const worker = new Worker('/assets/js/data/worker/api_thread_run.js');
    const postData = Object.assign({queryObject, isSp}, apiPathname, window.pist6);

    // console.log(postData);
    worker.postMessage(postData);
    worker.addEventListener('message', evt => {
      // データなし（該当データなし）の場合にリダイレクト
      if (evt.data.type == 'error') {
        set_redirect404();
        return;
      }

      if (isDomContentLoaded()) {
        processFunction[evt.data.type](evt.data);
      } else {
        window.addEventListener('DOMContentLoaded', () => {
          processFunction[evt.data.type](evt.data);
        })
      }
    })
  }

  // 返却データのtypeによって実行する関数を切り替え
  const processFunction = {
    base: (data) => {
      console.log('base', data);
      // buildSidebarRound(data.round, data.page);

      buildTournament(data.tournament, data.page);
      buildMigratoryRace(data.race, data.page.isClassificationAllRaceDiscontinuation, data.page.isClassificationAllRaceComingSoon, isSp);
      buildRunDateInfo(data.runInfo);
      setRaceStartTime(data.runInfo);
      setDiscontinuationLabel(data.runInfo.isRunDiscontinuation);
      buildRun(data.run, !!data.result, data.runInfo.isRunDiscontinuation, isSp);
      buildRaceName(data.page);

      // レース結果データの有無による表示切り替え
      if (data.result) {
        buildResult(data.result);
        // 'run' は出走表の為、常に表示する
        buildAnchor(['run', ...Object.keys(data.result)]);
      } else {
        discordResultRelativeElement();
      }
      buildKvTitle(data.page);
      document.getElementById('migratory').buildMigratory();
    },
    playerDetail: (data) => {
      console.log('playerDetail', data);
      buildModal(data.modalString, false);
    }
  }

  const buildRaceName = (pageData) => {
    const raceHeader = document.querySelector('.c-race-header');
    raceHeader.querySelector('.c-race-header__ttl-sub span').textContent = pageData.classification.en || 'ー';
    raceHeader.querySelector('.c-race-header__ttl-main span').textContent = pageData.classification.name || 'ー';

    raceHeader.classList.remove('_skelton');
    raceHeader.removeAttribute('aria-hidden');
  }

  const buildKvTitle = (pageData) => {
    const kvTtl = document.querySelector('.le-header__ttl');

    const ttlSub = kvTtl.querySelector('.le-header__ttl-sub span');
    ttlSub.innerHTML = `20${pageData.yearTxt} <span class="le-header__ttl-jp">${getCode('seasonText', pageData.season).ja} ${getCode('round', pageData.roundCode).name}</span>`

    kvTtl.classList.remove('_skelton');
    kvTtl.removeAttribute('aria-hidden');
  }

  const setRaceStartTime = (runInfo) => {
    const startTimeEle = document.querySelector('.le-race-time__clock');
    startTimeEle.textContent = runInfo.start;
  }
  const setDiscontinuationLabel = (isDiscontinuation) => {
    if (isDiscontinuation) {
      const raceHeaderDate = document.querySelector('.c-race-header__date');
      raceHeaderDate.appendChild(createDiscontinuationElement(raceHeaderDate.className));
    }
  }

  // 結果エリアの削除
  const discordResultRelativeElement = () => {
    document.getElementById('result').remove();
    document.getElementById('anchor').remove();
  }

  init();
}
